import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Category } from '../../core/models/menu.model';
import { DataService } from '../../core/services/data.service';
import { ImgSlotComponent } from './img-slot.component';
import { TranslatePipe } from '../pipes/translate.pipe';

const TONES: Record<string, string> = {
  burgers: 'beef', chicken: 'chicken', sides: 'fries', plant: 'plant', drinks: 'shake', dessert: 'dessert',
};

/** Category grid tile. */
@Component({
  selector: 'app-category-tile',
  standalone: true,
  imports: [ImgSlotComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<button (click)="open.emit(cat)"
      style="border:none;cursor:pointer;padding:0;text-align:start;background:transparent;display:flex;flex-direction:column;gap:8px;width:100%">
      <app-img-slot [src]="photo" [tone]="tone" [radius]="16"
        style="width:100%;aspect-ratio:1.35;box-shadow:var(--fr-shadow-sm)"></app-img-slot>
      <div>
        <div style="font-weight:700;font-size:14px;letter-spacing:-0.01em;color:var(--fr-text)">{{ cat.name | t }}</div>
        <div style="font-size:12px;color:var(--fr-text-3);margin-top:1px">{{ cat.count }} {{ 'items' | t }}</div>
      </div>
    </button>`,
})
export class CategoryTileComponent {
  @Input() cat!: Category;
  @Output() open = new EventEmitter<Category>();

  constructor(private data: DataService) {}
  get tone(): any { return TONES[this.cat.id] || 'beef'; }
  get photo(): string | null { return this.data.photoFor('cat-' + this.cat.id); }
}
